import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { Office, UpdateAgencyServicesCommand } from '../../../../models';
import { ApiService, ToastService } from '../../../../shared/services';
import { AgencyServicesFormComponent } from '../agency-services-form/agency-services-form.component';
import { BaseComponent } from '../../../general/base/base.component';

@Component({
  selector: 'app-agency-services',
  templateUrl: './agency-services.component.html',
  styleUrls: ['./agency-services.component.scss'],
})
export class AgencyServicesComponent extends BaseComponent {
  @Input() public office: Office | undefined = undefined;
  public isLoading = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private dialogService: DialogService,
    private toastService: ToastService,
  ) {
    super();
  }

  updateClicked() {
    const ref = this.dialogService.open(AgencyServicesFormComponent, {
      header: `Edit Agency Services`,
      width: '700px',
      height: 'auto',
      data: {
        office: this.office,
      },
    });

    ref.onClose.subscribe((command: UpdateAgencyServicesCommand) => {
      if (command) {
        this.isLoading = true;
        this.apiService.agencies.associateServicesToAgency(command.agencyId, command).subscribe(
          (agency) => {
            if (this.office) {
              this.office.agency = agency;
            }
            this.isLoading = false;
            this.toastService.send({
              severity: 'success',
              summary: 'Updated',
              detail: 'You have updated the services for this agency',
            });
          },
          () => {
            this.isLoading = false;
            this.toastService.send({
              severity: 'error',
              summary: 'Error',
              detail: 'There was an error updating the services for this agency',
            });
          },
        );
      }
    });
  }
}
